// Original Netflix-style character avatars, generated as inline SVG data URIs.
// Each avatar is a colourful rounded tile with a friendly character.

const wrap = (bg, inner) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='320' height='320' viewBox='0 0 320 320'><rect width='320' height='320' rx='20' fill='${bg}'/>${inner}</svg>`
  )}`;

const D = '#141414'; // dark features

export const AVATARS = [
  {
    id: 'smiley',
    name: 'Classic',
    src: wrap(
      '#e50914',
      `<circle cx='160' cy='140' r='60' fill='${D}'/><rect x='96' y='214' width='128' height='80' rx='40' fill='${D}'/><circle cx='138' cy='132' r='11' fill='#e50914'/><circle cx='182' cy='132' r='11' fill='#e50914'/><path d='M136 162 Q160 184 184 162' stroke='#e50914' stroke-width='10' fill='none' stroke-linecap='round'/>`
    ),
  },
  {
    id: 'cool',
    name: 'Cool',
    src: wrap(
      '#0aa1dd',
      `<circle cx='160' cy='140' r='60' fill='${D}'/><rect x='96' y='214' width='128' height='80' rx='40' fill='${D}'/><rect x='120' y='122' width='80' height='20' rx='8' fill='#0aa1dd'/><rect x='128' y='128' width='24' height='16' rx='6' fill='#0aa1dd'/><rect x='168' y='128' width='24' height='16' rx='6' fill='#0aa1dd'/><path d='M140 168 Q160 182 180 168' stroke='#0aa1dd' stroke-width='9' fill='none' stroke-linecap='round'/>`
    ),
  },
  {
    id: 'cat',
    name: 'Kitty',
    src: wrap(
      '#f5a623',
      `<path d='M108 96 L118 150 L150 132 Z' fill='${D}'/><path d='M212 96 L202 150 L170 132 Z' fill='${D}'/><circle cx='160' cy='160' r='58' fill='${D}'/><circle cx='140' cy='152' r='9' fill='#f5a623'/><circle cx='180' cy='152' r='9' fill='#f5a623'/><path d='M156 172 L164 172 L160 180 Z' fill='#f5a623'/><path d='M120 176 L96 170 M120 186 L96 190' stroke='#f5a623' stroke-width='4' stroke-linecap='round'/><path d='M200 176 L224 170 M200 186 L224 190' stroke='#f5a623' stroke-width='4' stroke-linecap='round'/>`
    ),
  },
  {
    id: 'robot',
    name: 'Robo',
    src: wrap(
      '#1abc9c',
      `<rect x='96' y='118' width='128' height='108' rx='20' fill='${D}'/><line x1='160' y1='118' x2='160' y2='92' stroke='${D}' stroke-width='8'/><circle cx='160' cy='86' r='12' fill='${D}'/><rect x='120' y='150' width='30' height='20' rx='6' fill='#1abc9c'/><rect x='170' y='150' width='30' height='20' rx='6' fill='#1abc9c'/><rect x='134' y='192' width='52' height='10' rx='5' fill='#1abc9c'/>`
    ),
  },
  {
    id: 'panda',
    name: 'Panda',
    src: wrap(
      '#f2f2f2',
      `<circle cx='118' cy='108' r='26' fill='${D}'/><circle cx='202' cy='108' r='26' fill='${D}'/><circle cx='160' cy='162' r='66' fill='#ffffff' stroke='${D}' stroke-width='6'/><ellipse cx='138' cy='152' rx='16' ry='20' fill='${D}'/><ellipse cx='182' cy='152' rx='16' ry='20' fill='${D}'/><circle cx='138' cy='154' r='6' fill='#fff'/><circle cx='182' cy='154' r='6' fill='#fff'/><ellipse cx='160' cy='182' rx='10' ry='7' fill='${D}'/>`
    ),
  },
  {
    id: 'alien',
    name: 'Alien',
    src: wrap(
      '#8e44ff',
      `<ellipse cx='160' cy='150' rx='58' ry='68' fill='${D}'/><ellipse cx='138' cy='150' rx='14' ry='22' fill='#8e44ff'/><ellipse cx='182' cy='150' rx='14' ry='22' fill='#8e44ff'/><path d='M144 194 Q160 204 176 194' stroke='#8e44ff' stroke-width='8' fill='none' stroke-linecap='round'/><line x1='160' y1='82' x2='160' y2='66' stroke='${D}' stroke-width='6'/><circle cx='160' cy='60' r='8' fill='${D}'/>`
    ),
  },
  {
    id: 'ninja',
    name: 'Ninja',
    src: wrap(
      '#34495e',
      `<circle cx='160' cy='150' r='62' fill='${D}'/><rect x='98' y='130' width='124' height='34' rx='10' fill='#34495e'/><rect x='130' y='138' width='24' height='16' rx='6' fill='${D}'/><rect x='166' y='138' width='24' height='16' rx='6' fill='${D}'/><path d='M222 132 L252 122 L246 148 Z' fill='#34495e'/>`
    ),
  },
  {
    id: 'star',
    name: 'Star',
    src: wrap(
      '#f1c40f',
      `<path d='M160 74 L184 132 L246 137 L198 178 L214 240 L160 206 L106 240 L122 178 L74 137 L136 132 Z' fill='${D}'/><circle cx='144' cy='158' r='8' fill='#f1c40f'/><circle cx='176' cy='158' r='8' fill='#f1c40f'/><path d='M148 178 Q160 188 172 178' stroke='#f1c40f' stroke-width='7' fill='none' stroke-linecap='round'/>`
    ),
  },
  {
    id: 'gamer',
    name: 'Gamer',
    src: wrap(
      '#e84393',
      `<rect x='84' y='134' width='152' height='72' rx='36' fill='${D}'/><circle cx='120' cy='170' r='16' fill='#e84393'/><circle cx='200' cy='170' r='16' fill='#e84393'/><rect x='112' y='166' width='16' height='8' rx='2' fill='${D}'/><rect x='116' y='162' width='8' height='16' rx='2' fill='${D}'/><circle cx='196' cy='166' r='5' fill='${D}'/><circle cx='206' cy='174' r='5' fill='${D}'/>`
    ),
  },
  {
    id: 'ghost',
    name: 'Boo',
    src: wrap(
      '#2d98da',
      `<path d='M104 200 V150 a56 56 0 0 1 112 0 V200 l-18 -14 -18 14 -19 -14 -19 14 -18 -14 Z' fill='#ffffff'/><circle cx='140' cy='150' r='9' fill='${D}'/><circle cx='180' cy='150' r='9' fill='${D}'/><ellipse cx='160' cy='176' rx='9' ry='12' fill='${D}'/>`
    ),
  },
];

export const DEFAULT_AVATAR = AVATARS[0].src;

export function avatarById(id) {
  const a = AVATARS.find((x) => x.id === id);
  return a ? a.src : DEFAULT_AVATAR;
}
